import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api/api.service';

@Component({
  selector: 'app-design-contact-log',
  templateUrl: './design-contact-log.component.html',
  styleUrls: ['./design-contact-log.component.less']
})
export class DesignContactLogComponent implements OnInit {

  tierList = ['Gold', 'Silver', 'Bronze+', 'Bronze'];
  searchValue: string = '';
  tierValue: string[] = [];
  partnersList: any[] = [];
  innerWidth: number;
  originalList: any[] = [];
  noMsg = ''
  isLoading: boolean;
descList:any[]=[];
  logsList:any[]=[];
  selectedDesc:any[]=[];
  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private router: Router
  ) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.api.getAllDesignEmailLog().subscribe((res:any)=>{
      
      this.logsList = res;
      this.descList = [...new Set(this.logsList.map((item:any)=> item.email_label))];
      this.logsList.forEach((element,index) => {
        element.showCopy=false;
        element.roomval = element.booking[0]?.room? this.api.getRoomValue(element.booking[0]?.room): '-';
        element.designer_assigned = element.booking[0]?.designer_assigned || '-';
        element.firstName = element.booking[0]?.first_name || '';
        element.lastName = element.booking[0]?.last_name || '';

      }); 
      this.originalList = JSON.parse(JSON.stringify(this.logsList));
   
      this.isLoading = false;
    })
  }

  filterByDesc(){
    if(this.selectedDesc.length){
      this.logsList = this.originalList.filter((item:any)=> this.selectedDesc.includes(item.email_label));
    } else {
      this.logsList = JSON.parse(JSON.stringify(this.originalList));
    }
  }

  openIntake(s:any){
    // admin/dashboard/design/rooms/{{room_id}}/contact-log
    this.router.navigate([]).then(() => {
      window.open(`admin/dashboard/design/rooms/${s.room_id}/contact-log`, '_blank');
    });
  }
  

  showCopy(index:number){
    this.logsList[index].showCopy=true;
  }

  hideCopy(index:number){
    this.logsList[index].showCopy=false;
  }
 copyToClipboard(text:string){
    navigator.clipboard.writeText(text).then(() => {
      this.snackbar.open('Copied to clipboard', 'Close', {
        duration: 2000,
      });
    });
  }

  @HostListener("window:resize")
  onResize() {
    this.innerWidth = this.api.isAdminSidePanelOpened ? window.innerWidth : window.innerWidth + 225;

  }

  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }
 

} 